import {
  TRUSTPILOT_POPUP_HEIGHT,
  TRUSTPILOT_POPUP_WIDTH,
} from '../constants';

export function openTrustpilotReview(url: string): Window | null {
  if (typeof window === 'undefined' || !url) return null;

  const width = TRUSTPILOT_POPUP_WIDTH;
  const height = TRUSTPILOT_POPUP_HEIGHT;

  const dualLeft = window.screenLeft ?? window.screenX ?? 0;
  const dualTop = window.screenTop ?? window.screenY ?? 0;
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth || width;
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight || height;

  const left = dualLeft + Math.max(0, (viewportWidth - width) / 2);
  const top = dualTop + Math.max(0, (viewportHeight - height) / 2);

  const features = [
    'popup=yes',
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'menubar=no',
    'toolbar=no',
    'location=no',
    'status=no',
    'resizable=yes',
    'scrollbars=yes',
  ].join(',');

  return window.open(url, 'trustpilot-review', features);
}
